// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"8bf5643f","647":"a4228af5"}[chunkId] + ".chunk.js";
};